import {useMemo} from 'react'

import {useIsAutodetectTimeZone} from '../../../../../hooks/useIsAutodetectTimeZone'
import useMyId from '../../../../../hooks/useMyId'
import type {TestOccurrenceId} from '../../../../../types'
import {InvestigationStates, stringifyId} from '../../../../../types'
import {UserProperties} from '../../../../../utils/userProperties'
import ContentPanel from '../../../../common/ContentPanel/ContentPanel'
import Icon from '../../../../common/Icon/Icon'
import InvestigationDetails from '../../../../common/Investigations/InvestigationDetails'
import {getTestOccurrenceInvestigations} from '../../../../packages/Tests/Tests.selectors'

import styles from './InvestigationsPanel.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  testOccurrenceId: TestOccurrenceId
  seqKey?: string
  seqOff?: boolean
}

function InvestigationsPanel({testOccurrenceId}: Props) {
  const currentUserId = useMyId()
  const isAutodetectTimeZone = useIsAutodetectTimeZone()

  const investigations = useAppSelector(state =>
    getTestOccurrenceInvestigations(state, testOccurrenceId),
  )

  const filteredInvestigations = useMemo(
    () =>
      investigations.filter(
        ({state}) =>
          state != null &&
          state !== InvestigationStates.GIVEN_UP &&
          state !== InvestigationStates.NONE,
      ),
    [investigations],
  )

  return filteredInvestigations.length > 0 ? (
    <ContentPanel
      panelType={UserProperties.EXPAND_TEST_HISTORY_INVESTIGATIONS_SECTION}
      heading={
        <div className={styles.heading}>
          <Icon
            className={styles.headingIcon}
            name="investigation"
            aria-label="investigation"
            title=""
          />
          <span>{'Investigations'}</span>
        </div>
      }
      content={
        <>
          {filteredInvestigations
            .filter(investigation => investigation != null)
            .map(investigation => (
              <div key={stringifyId(investigation.id)} className={styles.investigationDetails}>
                <InvestigationDetails
                  investigation={investigation}
                  currentUserId={currentUserId}
                  isAutodetectTimeZone={isAutodetectTimeZone}
                  highlightAssignedToMe
                />
              </div>
            ))}
        </>
      }
      withBorder={false}
    />
  ) : null
}

export default InvestigationsPanel
